export class LoginHocHelper {

  constructor(loginHoc){
    this.loginHoc = loginHoc;
  }

  navigateTOiEnergyLinkURL() {
    if (window.location.href.indexOf(app.appUtil.getAppConstants().GuestLoginConstants.FMEASURE) > -1) {
      app.appService.setLocalStorage(app.appUtil.getAppConstants().GuestLoginConstants.FMEASURE, true);
    } else {
      app.appService.deleteElementFromLocalStorage(app.appUtil.getAppConstants().GuestLoginConstants.FMEASURE);
    }

    if (window.location.href.indexOf(app.appUtil.getAppConstants().GuestLoginConstants.FACCOUNT) > -1) {
      app.appService.setLocalStorage(app.appUtil.getAppConstants().GuestLoginConstants.FACCOUNT, true);
    } else {
      app.appService.deleteElementFromLocalStorage(app.appUtil.getAppConstants().GuestLoginConstants.FACCOUNT);
    }
  }
  onKeyPressHandler = (e) => {
    if (e.key === 'Enter' || e.charCode === 13) {
      if (e.target.dataset.component === 'loginHomePage' && document.getElementById("HomeLoginButton")) {
        this.keyPressBlurHandler();
        window.setTimeout(() => {
          document.getElementById("HomeLoginButton").click();
        }, 100);
      } else if (e.target.dataset.component === 'innerLoginHeader' && document.getElementById("innerloginHeaderLoginBtn")) {
        this.keyPressBlurHandler();
        window.setTimeout(() => {
          document.getElementById("innerloginHeaderLoginBtn").click();
        }, 100);
      } else if (e.target.dataset.component === 'loginMain' && document.getElementById("LoginMainButton")) {
        this.keyPressBlurHandler();
        window.setTimeout(() => {
          document.getElementById("LoginMainButton").click();
        }, 100);
      }
    }
  }
  keyPressBlurHandler = () => {
    if (document.getElementById("password") || document.getElementById("userName")) {
      document.getElementById("password").blur();
      document.getElementById("userName").blur();
    }
  }
  handleLoginValidate(LoginInput, ErrorMsg, value) {
    app.logger.getLogger().entering('logIn');
    if (LoginInput.value !== '') {
      LoginInput.isValidated = true;
      LoginInput.isValid = true;
      if (LoginInput.id !== undefined && LoginInput.id === 'username') {
        this.loginHoc.handleEmailCheck(value);
        LoginInput.isError = !this.loginHoc.emailError;
        LoginInput.errorMsg = LoginInput.isError ? ErrorMsg : '';
      }
      if (LoginInput.id !== undefined && LoginInput.id === 'password') {
        this.loginHoc.handlepasswordCheck(value);
        LoginInput.isError = !this.loginHoc.passwordError;
        LoginInput.errorMsg = LoginInput.isError ? ErrorMsg : '';
      } else if (LoginInput.isError === undefined) {
        LoginInput.isError = false;
      }
    } else {
      LoginInput.isError = true;
      LoginInput.isValidated = true;
      LoginInput.isValid = false;
      LoginInput.errorMsg = ErrorMsg;
    }
    return LoginInput;
  }
  handleUserLogout() {
    app.pubSubService.unsubscribe('PubSubSessionExpiry');
    const isAuth = app.appService.isAuthenticated();
    if (isAuth === true) {
      app.identityService.logout().then(() => {
        let addToHomeScreenPopUpData = localStorage.getItem(window.location.hostname);
        let userRememberMe = app.appService.getSessionstorage('rememberMe');
        app.appService.deleteSessionData();
        app.appService.removeSessionStorageItem('handleNewVerificationFlag');
        let phoneNumber = app.appService.getLocalStorage("SelectedPhoneNumber");
        app.identityService.handleUserLogout();
        if (phoneNumber) {
          app.appService.setLocalStorage("SelectedPhoneNumber", phoneNumber);
        }
        if (addToHomeScreenPopUpData) {
          localStorage.setItem(window.location.hostname, addToHomeScreenPopUpData);
        }
        app.appService.setSessionstorage('rememberMe', userRememberMe);
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.LOGOUT);
      }, error => {
        app.logger.getLogger().error("error " + error);
      });
    } else {
      app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.LOGOUT);
    }
  }
  handleLoginInvalid(LoginInput, ErrorMsg) {
        LoginInput.isError = true;
        LoginInput.isValidated = true;
        LoginInput.isValid = false;
        LoginInput.errorMsg = ErrorMsg;
        return LoginInput;}
}
